import { render } from "./WaitingRoomPanel.vue?vue&type=template&id=2356e7f6&scoped=true"
import script from "./WaitingRoomPanel.vue?vue&type=script&lang=js"
export * from "./WaitingRoomPanel.vue?vue&type=script&lang=js"

import "./WaitingRoomPanel.vue?vue&type=style&index=0&id=2356e7f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2356e7f6"]])

export default __exports__